var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 78,
    viewBox: "0 0 184 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91086 64.3845C-3.16914 53.6045 2.31085 39.1445 13.2509 34.4345C24.1909 29.7245 38.4609 35.6845 42.8009 46.7845C43.0309 24.3545 61.3809 3.50449 83.6009 0.404488C105.821 -2.69551 129.161 12.3645 135.511 33.8745C139.761 28.4845 147.881 26.5845 154.081 29.5245C160.281 32.4745 163.931 39.9645 162.431 46.6645C168.011 40.9745 181.671 46.8345 183.111 54.6745C184.551 62.5145 178.731 70.2345 171.521 73.6545C164.311 77.0645 156.041 77.1745 148.071 77.2245C109.401 77.4445 70.7409 77.6645 32.0709 77.8845C20.0509 77.9545 7.04086 75.2545 1.91086 64.3745V64.3845Z",
    fill: "#D5E7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud04);
export default __webpack_public_path__ + "static/media/cloud04.94e491166d8eb13c5bd0678be1987344.svg";
export { ForwardRef as ReactComponent };